export enum NumberOfTireEnum {
  ONE_TIRE,
  TWO_TIRE,
  THREE_TIRE,
  FOUR_TIRE,
  FIVE_TIRE,
  SIX_TIRE,
}
